import { useQuery } from 'react-query';

import { api } from '../main-request/base';

const useGeneralApi = (url, params, options) => {
	return useQuery([url, params], async () => api.get(url, { params }), { ...options });
};

export default useGeneralApi;
